import { useCallback } from "react";
import { useUser } from "./useUser";

const KEY = "ignoreLoosingAccessToTransaction";

export function useIgnoreLoosingAccessToTransaction() {
    const user = useUser();
    const key = user ? KEY + user.id : null;
    const ignoreLoosingAccess = Boolean(key && localStorage.getItem(key));
    const setIgnoreLoosingAccess = useCallback(() => {
        if (!key) {
            return;
        }

        localStorage.setItem(key, "true");
    }, [key]);

    return {
        ignoreLoosingAccess,
        setIgnoreLoosingAccess,
    };
}
